'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _elementActions = require('../../../../element/elementActions');

var _popupActions = require('../../../../components/popupPanel/popupActions');

var _ColorButton = require('./ColorButton');

var _ColorButton2 = _interopRequireDefault(_ColorButton);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _colorConstants = require('../../../../../common/colors/colorConstants');

var _popupConstants = require('../../../../components/popupPanel/popupConstants');

require('./ColorPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getIsActive = function getIsActive(selectedIds, elements, color) {
    var isActive = true;
    selectedIds.forEach(function (elementId) {
        var element = elements.get(elementId);
        var elementColor = element.getIn(['content', 'color']);
        isActive = isActive && (!elementColor && !color || color && elementColor === color.name);
    });
    return isActive;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        setColor: function setColor(color) {
            var colorName = color ? color.name : null;
            dispatch((0, _elementActions.updateSelectedElements)({ changes: { color: colorName } }));
            dispatch((0, _popupActions.closePopup)());
        }
    };
};

var ColorPopup = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(ColorPopup, _React$Component);

    function ColorPopup() {
        _classCallCheck(this, ColorPopup);

        return _possibleConstructorReturn(this, (ColorPopup.__proto__ || Object.getPrototypeOf(ColorPopup)).apply(this, arguments));
    }

    _createClass(ColorPopup, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                setColor = _props.setColor,
                elements = _props.elements,
                selection = _props.selection,
                selectedType = _props.selectedType;


            return _react2.default.createElement(
                _PopupPanel2.default,
                { popupId: 'color', arrowDir: _popupConstants.ARROW_DIR.left, className: 'colorPopup' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'ul',
                        { className: 'colors' },
                        Object.keys(_colorConstants.COLORS).map(function (color) {
                            return _react2.default.createElement(
                                'li',
                                { key: color },
                                _react2.default.createElement(_ColorButton2.default, {
                                    selectedType: selectedType,
                                    setColor: setColor,
                                    color: _colorConstants.COLORS[color],
                                    isActive: getIsActive(selection, elements, _colorConstants.COLORS[color]) })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return ColorPopup;
}(_react2.default.Component)) || _class);
exports.default = ColorPopup;


ColorPopup.propTypes = {
    selectedType: _propTypes2.default.string,
    selection: _propTypes2.default.object,
    elements: _propTypes2.default.object,
    setColor: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/colorTools/ColorPopup.js
// module id = 2230
// module chunks = 0